import { Button, Typography } from "@mui/material";
import { CameraAlt } from "@mui/icons-material";
import { trackEvent } from "src/Amplitude";

const TreemapScreenshotButton = ({ echartRef }: any) => {
  const captureScreenshot = async () => {
    if (!echartRef.current) {
      console.error("ECharts instance not found");
      return;
    }

    const echartInstance = echartRef.current.getEchartsInstance();

    // Save the original size of the chart
    const originalWidth = echartInstance.getWidth();
    const originalHeight = echartInstance.getHeight();

    // Set the desired larger size of the chart
    const desiredWidth = 3200;
    const desiredHeight = 1000;

    // Resize the chart to the desired size
    echartInstance.resize({ width: desiredWidth, height: desiredHeight });

    // Wait for the next animation frame to ensure the resize is rendered
    await new Promise(requestAnimationFrame);

    // Get the rendered canvas from the ECharts instance
    const renderedCanvas = echartInstance.getRenderedCanvas({
      pixelRatio: 2, // Adjust pixel ratio if needed
      backgroundColor: "#fff", // Set background color if needed
    });

    // Create a new canvas for the final image (chart + watermark)
    const finalCanvas = document.createElement("canvas");
    const ctx = finalCanvas.getContext("2d");

    // Set the canvas size to match the chart, plus extra height for the logo and information
    const extraHeight = 50; // Adjust this value as needed
    finalCanvas.width = renderedCanvas.width;
    finalCanvas.height = renderedCanvas.height + extraHeight;

    if (!ctx) {
      console.error("Could not create 2D context");
      return;
    }

    // Draw the additional space at the top of the final canvas
    ctx.fillStyle = "#002035";
    ctx.fillRect(0, 0, finalCanvas.width, extraHeight);

    // Draw the chart onto the final canvas below the additional space
    ctx.drawImage(renderedCanvas, 0, extraHeight);

    // Add watermark
    const watermarkText = "Caleb & Brown";
    ctx.font = "32px Roobert";
    ctx.fillStyle = "white";
    ctx.fillText(watermarkText, 30, extraHeight - 10);

    // Add centered watermark logo with low opacity
    const centeredWatermark = "Caleb & Brown";
    ctx.font = "72px Roobert";
    ctx.fillStyle = "rgba(255, 255, 255, 0.1)";
    ctx.textAlign = "center";
    ctx.fillText(centeredWatermark, finalCanvas.width / 2 + 30, finalCanvas.height / 2 + 30);

    // Add today's date to the top right in sentence case
    const date = new Date().toLocaleDateString("en-GB", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    ctx.font = "32px Roobert";
    ctx.fillStyle = "white";
    ctx.textAlign = "right";
    ctx.fillText(date, finalCanvas.width - 10, extraHeight - 10);

    const dataURL = finalCanvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.download = "calebandbrown-token-map.png";
    link.href = dataURL;
    link.click();

    // Reset the chart to the original size
    echartInstance.resize({ width: originalWidth, height: originalHeight });
  };

  return (
    <Button
      onClick={() => {
        trackEvent("Share_Sectors_Screenshot");
        captureScreenshot();
      }}
      style={{ textTransform: "none" }}
      startIcon={<CameraAlt />}>
      <Typography>Share</Typography>
    </Button>
  );
};

export default TreemapScreenshotButton;
